// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AdapterAuth } from "./adapter-auth";
import { AdapterProtocol } from "./adapter-protocol";
import { AdapterType } from "./adapter-type";
import { LiftType } from "./lift-type";
import { VendorFloorIndexing } from "./vendor-floor-indexing";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Full adapter record matching the `adapters` `PostgreSQL` table.
 *
 * JSONB columns (interface, `offset_mapping`, `cdo_input`, etc.) are
 * hydrated from their corresponding *_binary bytea columns by
 * GORM `AfterFind` hooks. In this archive format we store BOTH:
 * - The binary `FlatBuffer` blob (for type-safe round-trip)
 * - A JSON string fallback (for human inspection / debugging)
 */
export class Adapter implements flatbuffers.IUnpackableObject<AdapterT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Adapter {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAdapter(bb: flatbuffers.ByteBuffer, obj?: Adapter): Adapter {
    return (obj || new Adapter()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsAdapter(bb: flatbuffers.ByteBuffer, obj?: Adapter): Adapter {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Adapter()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  leadingZeroesId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  version(): string;
  version(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  version(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): AdapterType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterType.REST;
  }

  protocolType(): AdapterProtocol {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterProtocol.MCE;
  }

  authType(): AdapterAuth {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterAuth.NONE;
  }

  liftType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  vendorFloorIndexing(): VendorFloorIndexing {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : VendorFloorIndexing.ONE_BASED;
  }

  /**
   * Binary `FlatBuffer` blobs — these ARE the authoritative data.
   * Each corresponds to a vendor/ or config/ schema root type.
   */
  cdoBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  cdoBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  cdoBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  interfaceBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  interfaceBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  interfaceBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  offsetMappingBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  offsetMappingBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  offsetMappingBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  dictionaryBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  dictionaryBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  dictionaryBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  socketMessagePriorityBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  socketMessagePriorityBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  socketMessagePriorityBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  authBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  authBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  authBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  bacnetConfigBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  bacnetConfigBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  bacnetConfigBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  bacnetMappingsBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  bacnetMappingsBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  bacnetMappingsBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  cdoTemplateBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  cdoTemplateBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  cdoTemplateBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  intraContentFlagsBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  intraContentFlagsBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  intraContentFlagsBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  /**
   * JSON string representations for debugging / migration.
   * These are derived from the binary fields and are NOT
   * authoritative — the binary is the source of truth.
   */
  interfaceJson(): string | null;
  interfaceJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  interfaceJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  offsetMappingJson(): string | null;
  offsetMappingJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  offsetMappingJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dictionaryJson(): string | null;
  dictionaryJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  dictionaryJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cdoInputJson(): string | null;
  cdoInputJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cdoInputJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cdoTemplateJson(): string | null;
  cdoTemplateJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cdoTemplateJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  socketMessagePriorityJson(): string | null;
  socketMessagePriorityJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  socketMessagePriorityJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  bacnetConfigJson(): string | null;
  bacnetConfigJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bacnetConfigJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  bacnetBankMappingsJson(): string | null;
  bacnetBankMappingsJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bacnetBankMappingsJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  intraContentFlagsJson(): string | null;
  intraContentFlagsJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  intraContentFlagsJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cdoSchemaName(): string | null;
  cdoSchemaName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cdoSchemaName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cdoSchemaVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
  }

  defaultFaultsConfiguration(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  defaultIconDefinitionConfiguration(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 70);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  faultsConfigShowCounter(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  faultsConfigDelaySeconds(): number {
    const offset = this.bb!.__offset(this.bb_pos, 74);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Fault configuration rules — JSON because the rule engine
   * schema is dynamic and defined at application level.
   */
  faultsConfigRulesJson(): string | null;
  faultsConfigRulesJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  faultsConfigRulesJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 76);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  totalBacnetChannels(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 78);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 80);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 82);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 84);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * One-hot exclusion configuration — the serialized
   * `OneHotExclusion.OneHotExclusionConfig` `FlatBuffer` held in the
   * `adapters.one_hot_exclusion_binary` bytea column.
   *
   * Why it MUST exist here: the exclusion config is what clears
   * value-typed state. Door states, direction arrows and drive state are
   * value-typed per the ADM handbook — nothing in the message stream ever
   * deactivates the previous value, so the only thing that evicts a stale
   * peer is a one-hot exclusion group. An export that omits this field
   * silently produces an adapter whose doors, direction arrows and drive
   * state LATCH forever on the importing system, with no error anywhere to
   * point at the cause.
   *
   * Why it is LAST: `FlatBuffers` assigns vtable slots in declaration order,
   * so a new field may only ever be APPENDED at the end of a table. Adding
   * it here (rather than beside the other `*_binary` fields, where it
   * logically belongs) keeps every previously exported `.lnx` file
   * readable — old writers simply leave the slot absent and readers get an
   * empty vector. Never move it up next to `intra_content_flags_binary`;
   * that would shift every following field's slot and silently
   * misinterpret every archived export.
   */
  oneHotExclusionBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 86);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  oneHotExclusionBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 86);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  oneHotExclusionBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 86);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  /**
   * Floor-numbering base for VALUE-encoded floor fields (car position).
   *
   * The wire VALUE the vendor reports for the LOWEST floor. A controller
   * that sends 1 for its bottom landing has `position_floor_base = 1`.
   *
   * This generalises `vendor_floor_indexing`, which can only express a base
   * of 0 or 1. That enum remains the legacy input and seeds this field on
   * import, so an adapter that never sets this behaves exactly as before.
   */
  positionFloorBase(): number {
    const offset = this.bb!.__offset(this.bb_pos, 88);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * Floor-numbering base for BIT-encoded floor fields (car and hall calls).
   *
   * The BIT INDEX the vendor uses for the LOWEST floor, counted from the
   * first byte the offset mapping assigns to that message. A controller
   * whose bottom landing occupies bit 0 has `call_floor_base = 0`; one that
   * reserves bit 0 and starts at bit 1 has `call_floor_base = 1`.
   *
   * Why this MUST be separate from `position_floor_base`: the two are not
   * the same quantity. A position base is an offset applied to a numeric
   * value; a call base is an index into a bitmask, and shifting it moves a
   * floor across a BYTE boundary every eight floors. Before this field
   * existed the bit path had no base at all — `generateFloorKeys` wired
   * floor i to bit i unconditionally, and `applyFloorIndexingOverride`
   * deliberately skipped `BitMessage` keys — so a controller whose call
   * bitmap disagreed with its position numbering could not be corrected by
   * any setting. Measured on a `CEC_RVU` site: car position spanned 1..18 for
   * an 18-floor bank while every call kind emitted 0, and answered car
   * calls sat exactly one floor low in 83.1% of 14,211 correlated events.
   *
   * Default 0 reproduces the previous hard-wired behaviour exactly.
   */
  callFloorBase(): number {
    const offset = this.bb!.__offset(this.bb_pos, 90);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * Hard ceiling on per-car key expansion. 0 means NO CAP.
   *
   * LN1's `.CFB` stores each car's offset per category independently, and
   * nothing forces two categories to walk at the same rate. When their
   * strides differ they eventually CROSS, and `offset_to_car_num` is keyed
   * on the BYTE alone — so the crossing byte silently resolves to one car
   * and that car reports the other's telemetry. Measured on a six-car site:
   * position walked 23 bytes per car from 131 while a control category
   * walked 16 from 168; they met at byte 200, which is car 4's position
   * register and car 3's control base. Car 3's dashboard tracked car 4.
   * Nothing errored, because nothing looked.
   *
   * This field is the bound. The editor projects the first colliding car
   * count from the authored offsets and fills it in; an operator may also
   * set it directly to stop expansion at a chosen count.
   *
   * WHY 0 MEANS NO CAP RATHER THAN "CAP AT ZERO CARS". `FlatBuffers` cannot
   * distinguish an absent scalar from one written at its default, so a
   * scalar cannot carry SQL NULL across this wire. The column behind it is
   * nullable and NULL is its "no cap" value, so the transport needs a
   * sentinel — and 0 is the only safe choice available, because a literal
   * cap of zero cars is meaningless (it would expand no cars at all) while
   * a cap of one is legitimate and must stay expressible. Encoders map NULL
   * to 0 and decoders map 0 back to NULL; every consumer clamps a stored
   * value to at least 1 before using it.
   */
  maxCars(): number {
    const offset = this.bb!.__offset(this.bb_pos, 92);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * Enables per-key `Key.direction` on this adapter's LN1-family keys.
   *
   * OFF by default, and off is enforced rather than merely displayed:
   * while it is false the server rejects any key whose `direction` is not
   * BOTH, the editor hides the per-key control, and offset-overlap
   * detection ignores the direction axis entirely. An adapter that never
   * sets this behaves, byte for byte, as it did before the field existed.
   *
   * Turning it back OFF while non-BOTH keys exist is rejected rather than
   * silently re-symmetrising a live mapping — that would quietly change
   * which LN2 message a wire address resolves to on a running controller.
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  directionAwareKeys(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 94);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Packed `Config.CommandAckConfig` held in the
   * `adapters.command_ack_binary` bytea column.
   *
   * APPENDED, for the reason spelled out on `one_hot_exclusion_binary`
   * above: `FlatBuffers` assigns vtable slots in declaration order, so a new
   * field may only ever go at the end. Placing it beside the other
   * `*_binary` fields, where it logically belongs, would shift every
   * following slot and silently misinterpret every archived export.
   */
  commandAckBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 96);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  commandAckBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 96);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  commandAckBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 96);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  static startAdapter(builder: flatbuffers.Builder) {
    builder.startObject(47);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addLeadingZeroesId(
    builder: flatbuffers.Builder,
    leadingZeroesIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, leadingZeroesIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addVersion(builder: flatbuffers.Builder, versionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, versionOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: AdapterType) {
    builder.addFieldInt8(5, type, AdapterType.REST);
  }

  static addProtocolType(builder: flatbuffers.Builder, protocolType: AdapterProtocol) {
    builder.addFieldInt8(6, protocolType, AdapterProtocol.MCE);
  }

  static addAuthType(builder: flatbuffers.Builder, authType: AdapterAuth) {
    builder.addFieldInt8(7, authType, AdapterAuth.NONE);
  }

  static addLiftType(builder: flatbuffers.Builder, liftType: LiftType) {
    builder.addFieldInt8(8, liftType, LiftType.ELEVATOR);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(9, +active, +true);
  }

  static addVendorFloorIndexing(
    builder: flatbuffers.Builder,
    vendorFloorIndexing: VendorFloorIndexing,
  ) {
    builder.addFieldInt8(10, vendorFloorIndexing, VendorFloorIndexing.ONE_BASED);
  }

  static addCdoBinary(builder: flatbuffers.Builder, cdoBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, cdoBinaryOffset, 0);
  }

  static createCdoBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCdoBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addInterfaceBinary(
    builder: flatbuffers.Builder,
    interfaceBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(12, interfaceBinaryOffset, 0);
  }

  static createInterfaceBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startInterfaceBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addOffsetMappingBinary(
    builder: flatbuffers.Builder,
    offsetMappingBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(13, offsetMappingBinaryOffset, 0);
  }

  static createOffsetMappingBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetMappingBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addDictionaryBinary(
    builder: flatbuffers.Builder,
    dictionaryBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(14, dictionaryBinaryOffset, 0);
  }

  static createDictionaryBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDictionaryBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addSocketMessagePriorityBinary(
    builder: flatbuffers.Builder,
    socketMessagePriorityBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(15, socketMessagePriorityBinaryOffset, 0);
  }

  static createSocketMessagePriorityBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startSocketMessagePriorityBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addAuthBinary(builder: flatbuffers.Builder, authBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, authBinaryOffset, 0);
  }

  static createAuthBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startAuthBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addBacnetConfigBinary(
    builder: flatbuffers.Builder,
    bacnetConfigBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(17, bacnetConfigBinaryOffset, 0);
  }

  static createBacnetConfigBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startBacnetConfigBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addBacnetMappingsBinary(
    builder: flatbuffers.Builder,
    bacnetMappingsBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(18, bacnetMappingsBinaryOffset, 0);
  }

  static createBacnetMappingsBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startBacnetMappingsBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCdoTemplateBinary(
    builder: flatbuffers.Builder,
    cdoTemplateBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(19, cdoTemplateBinaryOffset, 0);
  }

  static createCdoTemplateBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCdoTemplateBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addIntraContentFlagsBinary(
    builder: flatbuffers.Builder,
    intraContentFlagsBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(20, intraContentFlagsBinaryOffset, 0);
  }

  static createIntraContentFlagsBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startIntraContentFlagsBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addInterfaceJson(builder: flatbuffers.Builder, interfaceJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, interfaceJsonOffset, 0);
  }

  static addOffsetMappingJson(
    builder: flatbuffers.Builder,
    offsetMappingJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(22, offsetMappingJsonOffset, 0);
  }

  static addDictionaryJson(builder: flatbuffers.Builder, dictionaryJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(23, dictionaryJsonOffset, 0);
  }

  static addCdoInputJson(builder: flatbuffers.Builder, cdoInputJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(24, cdoInputJsonOffset, 0);
  }

  static addCdoTemplateJson(
    builder: flatbuffers.Builder,
    cdoTemplateJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(25, cdoTemplateJsonOffset, 0);
  }

  static addSocketMessagePriorityJson(
    builder: flatbuffers.Builder,
    socketMessagePriorityJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(26, socketMessagePriorityJsonOffset, 0);
  }

  static addBacnetConfigJson(
    builder: flatbuffers.Builder,
    bacnetConfigJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(27, bacnetConfigJsonOffset, 0);
  }

  static addBacnetBankMappingsJson(
    builder: flatbuffers.Builder,
    bacnetBankMappingsJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(28, bacnetBankMappingsJsonOffset, 0);
  }

  static addIntraContentFlagsJson(
    builder: flatbuffers.Builder,
    intraContentFlagsJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(29, intraContentFlagsJsonOffset, 0);
  }

  static addCdoSchemaName(builder: flatbuffers.Builder, cdoSchemaNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(30, cdoSchemaNameOffset, 0);
  }

  static addCdoSchemaVersion(builder: flatbuffers.Builder, cdoSchemaVersion: number) {
    builder.addFieldInt32(31, cdoSchemaVersion, 1);
  }

  static addDefaultFaultsConfiguration(
    builder: flatbuffers.Builder,
    defaultFaultsConfiguration: boolean,
  ) {
    builder.addFieldInt8(32, +defaultFaultsConfiguration, +true);
  }

  static addDefaultIconDefinitionConfiguration(
    builder: flatbuffers.Builder,
    defaultIconDefinitionConfiguration: boolean,
  ) {
    builder.addFieldInt8(33, +defaultIconDefinitionConfiguration, +true);
  }

  static addFaultsConfigShowCounter(
    builder: flatbuffers.Builder,
    faultsConfigShowCounter: boolean,
  ) {
    builder.addFieldInt8(34, +faultsConfigShowCounter, +false);
  }

  static addFaultsConfigDelaySeconds(
    builder: flatbuffers.Builder,
    faultsConfigDelaySeconds: number,
  ) {
    builder.addFieldInt32(35, faultsConfigDelaySeconds, 0);
  }

  static addFaultsConfigRulesJson(
    builder: flatbuffers.Builder,
    faultsConfigRulesJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(36, faultsConfigRulesJsonOffset, 0);
  }

  static addTotalBacnetChannels(builder: flatbuffers.Builder, totalBacnetChannels: bigint) {
    builder.addFieldInt64(37, totalBacnetChannels, 0n);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(38, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(39, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(40, deletedAtOffset, 0);
  }

  static addOneHotExclusionBinary(
    builder: flatbuffers.Builder,
    oneHotExclusionBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(41, oneHotExclusionBinaryOffset, 0);
  }

  static createOneHotExclusionBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startOneHotExclusionBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addPositionFloorBase(builder: flatbuffers.Builder, positionFloorBase: number) {
    builder.addFieldInt16(42, positionFloorBase, 0);
  }

  static addCallFloorBase(builder: flatbuffers.Builder, callFloorBase: number) {
    builder.addFieldInt16(43, callFloorBase, 0);
  }

  static addMaxCars(builder: flatbuffers.Builder, maxCars: number) {
    builder.addFieldInt16(44, maxCars, 0);
  }

  static addDirectionAwareKeys(builder: flatbuffers.Builder, directionAwareKeys: boolean) {
    builder.addFieldInt8(45, +directionAwareKeys, +false);
  }

  static addCommandAckBinary(
    builder: flatbuffers.Builder,
    commandAckBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(46, commandAckBinaryOffset, 0);
  }

  static createCommandAckBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCommandAckBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endAdapter(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 10); // name
    builder.requiredField(offset, 12); // version
    return offset;
  }

  unpack(): AdapterT {
    return new AdapterT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.leadingZeroesId() !== null ? this.leadingZeroesId()!.unpack() : null,
      this.name(),
      this.version(),
      this.type(),
      this.protocolType(),
      this.authType(),
      this.liftType(),
      this.active(),
      this.vendorFloorIndexing(),
      this.bb!.createScalarList<number>(this.cdoBinary.bind(this), this.cdoBinaryLength()),
      this.bb!.createScalarList<number>(
        this.interfaceBinary.bind(this),
        this.interfaceBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.offsetMappingBinary.bind(this),
        this.offsetMappingBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.dictionaryBinary.bind(this),
        this.dictionaryBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.socketMessagePriorityBinary.bind(this),
        this.socketMessagePriorityBinaryLength(),
      ),
      this.bb!.createScalarList<number>(this.authBinary.bind(this), this.authBinaryLength()),
      this.bb!.createScalarList<number>(
        this.bacnetConfigBinary.bind(this),
        this.bacnetConfigBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.bacnetMappingsBinary.bind(this),
        this.bacnetMappingsBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.cdoTemplateBinary.bind(this),
        this.cdoTemplateBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.intraContentFlagsBinary.bind(this),
        this.intraContentFlagsBinaryLength(),
      ),
      this.interfaceJson(),
      this.offsetMappingJson(),
      this.dictionaryJson(),
      this.cdoInputJson(),
      this.cdoTemplateJson(),
      this.socketMessagePriorityJson(),
      this.bacnetConfigJson(),
      this.bacnetBankMappingsJson(),
      this.intraContentFlagsJson(),
      this.cdoSchemaName(),
      this.cdoSchemaVersion(),
      this.defaultFaultsConfiguration(),
      this.defaultIconDefinitionConfiguration(),
      this.faultsConfigShowCounter(),
      this.faultsConfigDelaySeconds(),
      this.faultsConfigRulesJson(),
      this.totalBacnetChannels(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createScalarList<number>(
        this.oneHotExclusionBinary.bind(this),
        this.oneHotExclusionBinaryLength(),
      ),
      this.positionFloorBase(),
      this.callFloorBase(),
      this.maxCars(),
      this.directionAwareKeys(),
      this.bb!.createScalarList<number>(
        this.commandAckBinary.bind(this),
        this.commandAckBinaryLength(),
      ),
    );
  }

  unpackTo(_o: AdapterT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.leadingZeroesId = this.leadingZeroesId() !== null ? this.leadingZeroesId()!.unpack() : null;
    _o.name = this.name();
    _o.version = this.version();
    _o.type = this.type();
    _o.protocolType = this.protocolType();
    _o.authType = this.authType();
    _o.liftType = this.liftType();
    _o.active = this.active();
    _o.vendorFloorIndexing = this.vendorFloorIndexing();
    _o.cdoBinary = this.bb!.createScalarList<number>(
      this.cdoBinary.bind(this),
      this.cdoBinaryLength(),
    );
    _o.interfaceBinary = this.bb!.createScalarList<number>(
      this.interfaceBinary.bind(this),
      this.interfaceBinaryLength(),
    );
    _o.offsetMappingBinary = this.bb!.createScalarList<number>(
      this.offsetMappingBinary.bind(this),
      this.offsetMappingBinaryLength(),
    );
    _o.dictionaryBinary = this.bb!.createScalarList<number>(
      this.dictionaryBinary.bind(this),
      this.dictionaryBinaryLength(),
    );
    _o.socketMessagePriorityBinary = this.bb!.createScalarList<number>(
      this.socketMessagePriorityBinary.bind(this),
      this.socketMessagePriorityBinaryLength(),
    );
    _o.authBinary = this.bb!.createScalarList<number>(
      this.authBinary.bind(this),
      this.authBinaryLength(),
    );
    _o.bacnetConfigBinary = this.bb!.createScalarList<number>(
      this.bacnetConfigBinary.bind(this),
      this.bacnetConfigBinaryLength(),
    );
    _o.bacnetMappingsBinary = this.bb!.createScalarList<number>(
      this.bacnetMappingsBinary.bind(this),
      this.bacnetMappingsBinaryLength(),
    );
    _o.cdoTemplateBinary = this.bb!.createScalarList<number>(
      this.cdoTemplateBinary.bind(this),
      this.cdoTemplateBinaryLength(),
    );
    _o.intraContentFlagsBinary = this.bb!.createScalarList<number>(
      this.intraContentFlagsBinary.bind(this),
      this.intraContentFlagsBinaryLength(),
    );
    _o.interfaceJson = this.interfaceJson();
    _o.offsetMappingJson = this.offsetMappingJson();
    _o.dictionaryJson = this.dictionaryJson();
    _o.cdoInputJson = this.cdoInputJson();
    _o.cdoTemplateJson = this.cdoTemplateJson();
    _o.socketMessagePriorityJson = this.socketMessagePriorityJson();
    _o.bacnetConfigJson = this.bacnetConfigJson();
    _o.bacnetBankMappingsJson = this.bacnetBankMappingsJson();
    _o.intraContentFlagsJson = this.intraContentFlagsJson();
    _o.cdoSchemaName = this.cdoSchemaName();
    _o.cdoSchemaVersion = this.cdoSchemaVersion();
    _o.defaultFaultsConfiguration = this.defaultFaultsConfiguration();
    _o.defaultIconDefinitionConfiguration = this.defaultIconDefinitionConfiguration();
    _o.faultsConfigShowCounter = this.faultsConfigShowCounter();
    _o.faultsConfigDelaySeconds = this.faultsConfigDelaySeconds();
    _o.faultsConfigRulesJson = this.faultsConfigRulesJson();
    _o.totalBacnetChannels = this.totalBacnetChannels();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.oneHotExclusionBinary = this.bb!.createScalarList<number>(
      this.oneHotExclusionBinary.bind(this),
      this.oneHotExclusionBinaryLength(),
    );
    _o.positionFloorBase = this.positionFloorBase();
    _o.callFloorBase = this.callFloorBase();
    _o.maxCars = this.maxCars();
    _o.directionAwareKeys = this.directionAwareKeys();
    _o.commandAckBinary = this.bb!.createScalarList<number>(
      this.commandAckBinary.bind(this),
      this.commandAckBinaryLength(),
    );
  }

  unpackFields(...fields: string[]): AdapterT {
    const t = new AdapterT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("leading_zeroes_id")) {
      t.leadingZeroesId = this.leadingZeroesId() !== null ? this.leadingZeroesId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("version")) {
      t.version = this.version();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("protocol_type")) {
      t.protocolType = this.protocolType();
    }
    if (fieldSet.has("auth_type")) {
      t.authType = this.authType();
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("vendor_floor_indexing")) {
      t.vendorFloorIndexing = this.vendorFloorIndexing();
    }
    if (fieldSet.has("cdo_binary")) {
      t.cdoBinary = this.bb!.createScalarList<number>(
        this.cdoBinary.bind(this),
        this.cdoBinaryLength(),
      );
    }
    if (fieldSet.has("interface_binary")) {
      t.interfaceBinary = this.bb!.createScalarList<number>(
        this.interfaceBinary.bind(this),
        this.interfaceBinaryLength(),
      );
    }
    if (fieldSet.has("offset_mapping_binary")) {
      t.offsetMappingBinary = this.bb!.createScalarList<number>(
        this.offsetMappingBinary.bind(this),
        this.offsetMappingBinaryLength(),
      );
    }
    if (fieldSet.has("dictionary_binary")) {
      t.dictionaryBinary = this.bb!.createScalarList<number>(
        this.dictionaryBinary.bind(this),
        this.dictionaryBinaryLength(),
      );
    }
    if (fieldSet.has("socket_message_priority_binary")) {
      t.socketMessagePriorityBinary = this.bb!.createScalarList<number>(
        this.socketMessagePriorityBinary.bind(this),
        this.socketMessagePriorityBinaryLength(),
      );
    }
    if (fieldSet.has("auth_binary")) {
      t.authBinary = this.bb!.createScalarList<number>(
        this.authBinary.bind(this),
        this.authBinaryLength(),
      );
    }
    if (fieldSet.has("bacnet_config_binary")) {
      t.bacnetConfigBinary = this.bb!.createScalarList<number>(
        this.bacnetConfigBinary.bind(this),
        this.bacnetConfigBinaryLength(),
      );
    }
    if (fieldSet.has("bacnet_mappings_binary")) {
      t.bacnetMappingsBinary = this.bb!.createScalarList<number>(
        this.bacnetMappingsBinary.bind(this),
        this.bacnetMappingsBinaryLength(),
      );
    }
    if (fieldSet.has("cdo_template_binary")) {
      t.cdoTemplateBinary = this.bb!.createScalarList<number>(
        this.cdoTemplateBinary.bind(this),
        this.cdoTemplateBinaryLength(),
      );
    }
    if (fieldSet.has("intra_content_flags_binary")) {
      t.intraContentFlagsBinary = this.bb!.createScalarList<number>(
        this.intraContentFlagsBinary.bind(this),
        this.intraContentFlagsBinaryLength(),
      );
    }
    if (fieldSet.has("interface_json")) {
      t.interfaceJson = this.interfaceJson();
    }
    if (fieldSet.has("offset_mapping_json")) {
      t.offsetMappingJson = this.offsetMappingJson();
    }
    if (fieldSet.has("dictionary_json")) {
      t.dictionaryJson = this.dictionaryJson();
    }
    if (fieldSet.has("cdo_input_json")) {
      t.cdoInputJson = this.cdoInputJson();
    }
    if (fieldSet.has("cdo_template_json")) {
      t.cdoTemplateJson = this.cdoTemplateJson();
    }
    if (fieldSet.has("socket_message_priority_json")) {
      t.socketMessagePriorityJson = this.socketMessagePriorityJson();
    }
    if (fieldSet.has("bacnet_config_json")) {
      t.bacnetConfigJson = this.bacnetConfigJson();
    }
    if (fieldSet.has("bacnet_bank_mappings_json")) {
      t.bacnetBankMappingsJson = this.bacnetBankMappingsJson();
    }
    if (fieldSet.has("intra_content_flags_json")) {
      t.intraContentFlagsJson = this.intraContentFlagsJson();
    }
    if (fieldSet.has("cdo_schema_name")) {
      t.cdoSchemaName = this.cdoSchemaName();
    }
    if (fieldSet.has("cdo_schema_version")) {
      t.cdoSchemaVersion = this.cdoSchemaVersion();
    }
    if (fieldSet.has("default_faults_configuration")) {
      t.defaultFaultsConfiguration = this.defaultFaultsConfiguration();
    }
    if (fieldSet.has("default_icon_definition_configuration")) {
      t.defaultIconDefinitionConfiguration = this.defaultIconDefinitionConfiguration();
    }
    if (fieldSet.has("faults_config_show_counter")) {
      t.faultsConfigShowCounter = this.faultsConfigShowCounter();
    }
    if (fieldSet.has("faults_config_delay_seconds")) {
      t.faultsConfigDelaySeconds = this.faultsConfigDelaySeconds();
    }
    if (fieldSet.has("faults_config_rules_json")) {
      t.faultsConfigRulesJson = this.faultsConfigRulesJson();
    }
    if (fieldSet.has("total_bacnet_channels")) {
      t.totalBacnetChannels = this.totalBacnetChannels();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("one_hot_exclusion_binary")) {
      t.oneHotExclusionBinary = this.bb!.createScalarList<number>(
        this.oneHotExclusionBinary.bind(this),
        this.oneHotExclusionBinaryLength(),
      );
    }
    if (fieldSet.has("position_floor_base")) {
      t.positionFloorBase = this.positionFloorBase();
    }
    if (fieldSet.has("call_floor_base")) {
      t.callFloorBase = this.callFloorBase();
    }
    if (fieldSet.has("max_cars")) {
      t.maxCars = this.maxCars();
    }
    if (fieldSet.has("direction_aware_keys")) {
      t.directionAwareKeys = this.directionAwareKeys();
    }
    if (fieldSet.has("command_ack_binary")) {
      t.commandAckBinary = this.bb!.createScalarList<number>(
        this.commandAckBinary.bind(this),
        this.commandAckBinaryLength(),
      );
    }
    return t;
  }
}

export class AdapterT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public leadingZeroesId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public version: string | Uint8Array | null = null,
    public type: AdapterType = AdapterType.REST,
    public protocolType: AdapterProtocol = AdapterProtocol.MCE,
    public authType: AdapterAuth = AdapterAuth.NONE,
    public liftType: LiftType = LiftType.ELEVATOR,
    public active: boolean = true,
    public vendorFloorIndexing: VendorFloorIndexing = VendorFloorIndexing.ONE_BASED,
    public cdoBinary: number[] = [],
    public interfaceBinary: number[] = [],
    public offsetMappingBinary: number[] = [],
    public dictionaryBinary: number[] = [],
    public socketMessagePriorityBinary: number[] = [],
    public authBinary: number[] = [],
    public bacnetConfigBinary: number[] = [],
    public bacnetMappingsBinary: number[] = [],
    public cdoTemplateBinary: number[] = [],
    public intraContentFlagsBinary: number[] = [],
    public interfaceJson: string | Uint8Array | null = null,
    public offsetMappingJson: string | Uint8Array | null = null,
    public dictionaryJson: string | Uint8Array | null = null,
    public cdoInputJson: string | Uint8Array | null = null,
    public cdoTemplateJson: string | Uint8Array | null = null,
    public socketMessagePriorityJson: string | Uint8Array | null = null,
    public bacnetConfigJson: string | Uint8Array | null = null,
    public bacnetBankMappingsJson: string | Uint8Array | null = null,
    public intraContentFlagsJson: string | Uint8Array | null = null,
    public cdoSchemaName: string | Uint8Array | null = null,
    public cdoSchemaVersion: number = 1,
    public defaultFaultsConfiguration: boolean = true,
    public defaultIconDefinitionConfiguration: boolean = true,
    public faultsConfigShowCounter: boolean = false,
    public faultsConfigDelaySeconds: number = 0,
    public faultsConfigRulesJson: string | Uint8Array | null = null,
    public totalBacnetChannels: bigint = 0n,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public oneHotExclusionBinary: number[] = [],
    public positionFloorBase: number = 0,
    public callFloorBase: number = 0,
    public maxCars: number = 0,
    public directionAwareKeys: boolean = false,
    public commandAckBinary: number[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    if (this.version === null || this.version === undefined) {
      throw new Error('Required field "version" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const leadingZeroesId = this.leadingZeroesId !== null ? this.leadingZeroesId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const version = this.version !== null ? builder.createString(this.version!) : 0;
    const cdoBinary = Adapter.createCdoBinaryVector(builder, this.cdoBinary);
    const interfaceBinary = Adapter.createInterfaceBinaryVector(builder, this.interfaceBinary);
    const offsetMappingBinary = Adapter.createOffsetMappingBinaryVector(
      builder,
      this.offsetMappingBinary,
    );
    const dictionaryBinary = Adapter.createDictionaryBinaryVector(builder, this.dictionaryBinary);
    const socketMessagePriorityBinary = Adapter.createSocketMessagePriorityBinaryVector(
      builder,
      this.socketMessagePriorityBinary,
    );
    const authBinary = Adapter.createAuthBinaryVector(builder, this.authBinary);
    const bacnetConfigBinary = Adapter.createBacnetConfigBinaryVector(
      builder,
      this.bacnetConfigBinary,
    );
    const bacnetMappingsBinary = Adapter.createBacnetMappingsBinaryVector(
      builder,
      this.bacnetMappingsBinary,
    );
    const cdoTemplateBinary = Adapter.createCdoTemplateBinaryVector(
      builder,
      this.cdoTemplateBinary,
    );
    const intraContentFlagsBinary = Adapter.createIntraContentFlagsBinaryVector(
      builder,
      this.intraContentFlagsBinary,
    );
    const interfaceJson =
      this.interfaceJson !== null ? builder.createString(this.interfaceJson!) : 0;
    const offsetMappingJson =
      this.offsetMappingJson !== null ? builder.createString(this.offsetMappingJson!) : 0;
    const dictionaryJson =
      this.dictionaryJson !== null ? builder.createString(this.dictionaryJson!) : 0;
    const cdoInputJson = this.cdoInputJson !== null ? builder.createString(this.cdoInputJson!) : 0;
    const cdoTemplateJson =
      this.cdoTemplateJson !== null ? builder.createString(this.cdoTemplateJson!) : 0;
    const socketMessagePriorityJson =
      this.socketMessagePriorityJson !== null
        ? builder.createString(this.socketMessagePriorityJson!)
        : 0;
    const bacnetConfigJson =
      this.bacnetConfigJson !== null ? builder.createString(this.bacnetConfigJson!) : 0;
    const bacnetBankMappingsJson =
      this.bacnetBankMappingsJson !== null ? builder.createString(this.bacnetBankMappingsJson!) : 0;
    const intraContentFlagsJson =
      this.intraContentFlagsJson !== null ? builder.createString(this.intraContentFlagsJson!) : 0;
    const cdoSchemaName =
      this.cdoSchemaName !== null ? builder.createString(this.cdoSchemaName!) : 0;
    const faultsConfigRulesJson =
      this.faultsConfigRulesJson !== null ? builder.createString(this.faultsConfigRulesJson!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const oneHotExclusionBinary = Adapter.createOneHotExclusionBinaryVector(
      builder,
      this.oneHotExclusionBinary,
    );
    const commandAckBinary = Adapter.createCommandAckBinaryVector(builder, this.commandAckBinary);

    Adapter.startAdapter(builder);
    Adapter.addId(builder, id);
    Adapter.addLeadingZeroesId(builder, leadingZeroesId);
    Adapter.addName(builder, name);
    Adapter.addVersion(builder, version);
    Adapter.addType(builder, this.type);
    Adapter.addProtocolType(builder, this.protocolType);
    Adapter.addAuthType(builder, this.authType);
    Adapter.addLiftType(builder, this.liftType);
    Adapter.addActive(builder, this.active);
    Adapter.addVendorFloorIndexing(builder, this.vendorFloorIndexing);
    Adapter.addCdoBinary(builder, cdoBinary);
    Adapter.addInterfaceBinary(builder, interfaceBinary);
    Adapter.addOffsetMappingBinary(builder, offsetMappingBinary);
    Adapter.addDictionaryBinary(builder, dictionaryBinary);
    Adapter.addSocketMessagePriorityBinary(builder, socketMessagePriorityBinary);
    Adapter.addAuthBinary(builder, authBinary);
    Adapter.addBacnetConfigBinary(builder, bacnetConfigBinary);
    Adapter.addBacnetMappingsBinary(builder, bacnetMappingsBinary);
    Adapter.addCdoTemplateBinary(builder, cdoTemplateBinary);
    Adapter.addIntraContentFlagsBinary(builder, intraContentFlagsBinary);
    Adapter.addInterfaceJson(builder, interfaceJson);
    Adapter.addOffsetMappingJson(builder, offsetMappingJson);
    Adapter.addDictionaryJson(builder, dictionaryJson);
    Adapter.addCdoInputJson(builder, cdoInputJson);
    Adapter.addCdoTemplateJson(builder, cdoTemplateJson);
    Adapter.addSocketMessagePriorityJson(builder, socketMessagePriorityJson);
    Adapter.addBacnetConfigJson(builder, bacnetConfigJson);
    Adapter.addBacnetBankMappingsJson(builder, bacnetBankMappingsJson);
    Adapter.addIntraContentFlagsJson(builder, intraContentFlagsJson);
    Adapter.addCdoSchemaName(builder, cdoSchemaName);
    Adapter.addCdoSchemaVersion(builder, this.cdoSchemaVersion);
    Adapter.addDefaultFaultsConfiguration(builder, this.defaultFaultsConfiguration);
    Adapter.addDefaultIconDefinitionConfiguration(builder, this.defaultIconDefinitionConfiguration);
    Adapter.addFaultsConfigShowCounter(builder, this.faultsConfigShowCounter);
    Adapter.addFaultsConfigDelaySeconds(builder, this.faultsConfigDelaySeconds);
    Adapter.addFaultsConfigRulesJson(builder, faultsConfigRulesJson);
    Adapter.addTotalBacnetChannels(builder, this.totalBacnetChannels);
    Adapter.addCreatedAt(builder, createdAt);
    Adapter.addUpdatedAt(builder, updatedAt);
    Adapter.addDeletedAt(builder, deletedAt);
    Adapter.addOneHotExclusionBinary(builder, oneHotExclusionBinary);
    Adapter.addPositionFloorBase(builder, this.positionFloorBase);
    Adapter.addCallFloorBase(builder, this.callFloorBase);
    Adapter.addMaxCars(builder, this.maxCars);
    Adapter.addDirectionAwareKeys(builder, this.directionAwareKeys);
    Adapter.addCommandAckBinary(builder, commandAckBinary);

    return Adapter.endAdapter(builder);
  }

  clone(): AdapterT {
    const obj = new AdapterT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.leadingZeroesId = this.leadingZeroesId !== null ? this.leadingZeroesId!.clone() : null;
    obj.name = this.name;
    obj.version = this.version;
    obj.type = this.type;
    obj.protocolType = this.protocolType;
    obj.authType = this.authType;
    obj.liftType = this.liftType;
    obj.active = this.active;
    obj.vendorFloorIndexing = this.vendorFloorIndexing;
    obj.cdoBinary = [...this.cdoBinary];
    obj.interfaceBinary = [...this.interfaceBinary];
    obj.offsetMappingBinary = [...this.offsetMappingBinary];
    obj.dictionaryBinary = [...this.dictionaryBinary];
    obj.socketMessagePriorityBinary = [...this.socketMessagePriorityBinary];
    obj.authBinary = [...this.authBinary];
    obj.bacnetConfigBinary = [...this.bacnetConfigBinary];
    obj.bacnetMappingsBinary = [...this.bacnetMappingsBinary];
    obj.cdoTemplateBinary = [...this.cdoTemplateBinary];
    obj.intraContentFlagsBinary = [...this.intraContentFlagsBinary];
    obj.interfaceJson = this.interfaceJson;
    obj.offsetMappingJson = this.offsetMappingJson;
    obj.dictionaryJson = this.dictionaryJson;
    obj.cdoInputJson = this.cdoInputJson;
    obj.cdoTemplateJson = this.cdoTemplateJson;
    obj.socketMessagePriorityJson = this.socketMessagePriorityJson;
    obj.bacnetConfigJson = this.bacnetConfigJson;
    obj.bacnetBankMappingsJson = this.bacnetBankMappingsJson;
    obj.intraContentFlagsJson = this.intraContentFlagsJson;
    obj.cdoSchemaName = this.cdoSchemaName;
    obj.cdoSchemaVersion = this.cdoSchemaVersion;
    obj.defaultFaultsConfiguration = this.defaultFaultsConfiguration;
    obj.defaultIconDefinitionConfiguration = this.defaultIconDefinitionConfiguration;
    obj.faultsConfigShowCounter = this.faultsConfigShowCounter;
    obj.faultsConfigDelaySeconds = this.faultsConfigDelaySeconds;
    obj.faultsConfigRulesJson = this.faultsConfigRulesJson;
    obj.totalBacnetChannels = this.totalBacnetChannels;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.oneHotExclusionBinary = [...this.oneHotExclusionBinary];
    obj.positionFloorBase = this.positionFloorBase;
    obj.callFloorBase = this.callFloorBase;
    obj.maxCars = this.maxCars;
    obj.directionAwareKeys = this.directionAwareKeys;
    obj.commandAckBinary = [...this.commandAckBinary];
    return obj;
  }

  equals(other: AdapterT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.leadingZeroesId !== null && other.leadingZeroesId !== null) {
      if (!this.leadingZeroesId!.equals(other.leadingZeroesId!)) return false;
    } else if (this.leadingZeroesId !== other.leadingZeroesId) return false;
    if (this.name !== other.name) return false;
    if (this.version !== other.version) return false;
    if (this.type !== other.type) return false;
    if (this.protocolType !== other.protocolType) return false;
    if (this.authType !== other.authType) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.active !== other.active) return false;
    if (this.vendorFloorIndexing !== other.vendorFloorIndexing) return false;
    if (this.cdoBinary.length !== other.cdoBinary.length) return false;
    for (let i = 0; i < this.cdoBinary.length; i++) {
      if (this.cdoBinary[i] !== other.cdoBinary[i]) return false;
    }
    if (this.interfaceBinary.length !== other.interfaceBinary.length) return false;
    for (let i = 0; i < this.interfaceBinary.length; i++) {
      if (this.interfaceBinary[i] !== other.interfaceBinary[i]) return false;
    }
    if (this.offsetMappingBinary.length !== other.offsetMappingBinary.length) return false;
    for (let i = 0; i < this.offsetMappingBinary.length; i++) {
      if (this.offsetMappingBinary[i] !== other.offsetMappingBinary[i]) return false;
    }
    if (this.dictionaryBinary.length !== other.dictionaryBinary.length) return false;
    for (let i = 0; i < this.dictionaryBinary.length; i++) {
      if (this.dictionaryBinary[i] !== other.dictionaryBinary[i]) return false;
    }
    if (this.socketMessagePriorityBinary.length !== other.socketMessagePriorityBinary.length)
      return false;
    for (let i = 0; i < this.socketMessagePriorityBinary.length; i++) {
      if (this.socketMessagePriorityBinary[i] !== other.socketMessagePriorityBinary[i])
        return false;
    }
    if (this.authBinary.length !== other.authBinary.length) return false;
    for (let i = 0; i < this.authBinary.length; i++) {
      if (this.authBinary[i] !== other.authBinary[i]) return false;
    }
    if (this.bacnetConfigBinary.length !== other.bacnetConfigBinary.length) return false;
    for (let i = 0; i < this.bacnetConfigBinary.length; i++) {
      if (this.bacnetConfigBinary[i] !== other.bacnetConfigBinary[i]) return false;
    }
    if (this.bacnetMappingsBinary.length !== other.bacnetMappingsBinary.length) return false;
    for (let i = 0; i < this.bacnetMappingsBinary.length; i++) {
      if (this.bacnetMappingsBinary[i] !== other.bacnetMappingsBinary[i]) return false;
    }
    if (this.cdoTemplateBinary.length !== other.cdoTemplateBinary.length) return false;
    for (let i = 0; i < this.cdoTemplateBinary.length; i++) {
      if (this.cdoTemplateBinary[i] !== other.cdoTemplateBinary[i]) return false;
    }
    if (this.intraContentFlagsBinary.length !== other.intraContentFlagsBinary.length) return false;
    for (let i = 0; i < this.intraContentFlagsBinary.length; i++) {
      if (this.intraContentFlagsBinary[i] !== other.intraContentFlagsBinary[i]) return false;
    }
    if (this.interfaceJson !== other.interfaceJson) return false;
    if (this.offsetMappingJson !== other.offsetMappingJson) return false;
    if (this.dictionaryJson !== other.dictionaryJson) return false;
    if (this.cdoInputJson !== other.cdoInputJson) return false;
    if (this.cdoTemplateJson !== other.cdoTemplateJson) return false;
    if (this.socketMessagePriorityJson !== other.socketMessagePriorityJson) return false;
    if (this.bacnetConfigJson !== other.bacnetConfigJson) return false;
    if (this.bacnetBankMappingsJson !== other.bacnetBankMappingsJson) return false;
    if (this.intraContentFlagsJson !== other.intraContentFlagsJson) return false;
    if (this.cdoSchemaName !== other.cdoSchemaName) return false;
    if (this.cdoSchemaVersion !== other.cdoSchemaVersion) return false;
    if (this.defaultFaultsConfiguration !== other.defaultFaultsConfiguration) return false;
    if (this.defaultIconDefinitionConfiguration !== other.defaultIconDefinitionConfiguration)
      return false;
    if (this.faultsConfigShowCounter !== other.faultsConfigShowCounter) return false;
    if (this.faultsConfigDelaySeconds !== other.faultsConfigDelaySeconds) return false;
    if (this.faultsConfigRulesJson !== other.faultsConfigRulesJson) return false;
    if (this.totalBacnetChannels !== other.totalBacnetChannels) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.oneHotExclusionBinary.length !== other.oneHotExclusionBinary.length) return false;
    for (let i = 0; i < this.oneHotExclusionBinary.length; i++) {
      if (this.oneHotExclusionBinary[i] !== other.oneHotExclusionBinary[i]) return false;
    }
    if (this.positionFloorBase !== other.positionFloorBase) return false;
    if (this.callFloorBase !== other.callFloorBase) return false;
    if (this.maxCars !== other.maxCars) return false;
    if (this.directionAwareKeys !== other.directionAwareKeys) return false;
    if (this.commandAckBinary.length !== other.commandAckBinary.length) return false;
    for (let i = 0; i < this.commandAckBinary.length; i++) {
      if (this.commandAckBinary[i] !== other.commandAckBinary[i]) return false;
    }
    return true;
  }
}

export function verifyAdapter(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "version");
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 1);
    verifier.checkScalarField(tablePos, 24, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 50);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 54);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 56);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 60);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 62);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 64);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 66, 4);
    verifier.checkScalarField(tablePos, 68, 1);
    verifier.checkScalarField(tablePos, 70, 1);
    verifier.checkScalarField(tablePos, 72, 1);
    verifier.checkScalarField(tablePos, 74, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 76);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 78, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 80);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 82);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 84);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 86);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkScalarField(tablePos, 88, 2);
    verifier.checkScalarField(tablePos, 90, 2);
    verifier.checkScalarField(tablePos, 92, 2);
    verifier.checkScalarField(tablePos, 94, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 96);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
